import { useEffect } from 'react';
import { Wizard, WizardProps } from '@/_shared/components/Wizard';
import { wizardStore } from '@/_shared/components/Wizard/store';
import { EmployeeCompleteSurvey } from './EmployeeCompleteSurvey';
import { EmployeeStartSurvey } from './EmployeeStartSurvey';
import { ConfigurationCompletedThankYouPage } from './TYP';

export const WizardSurvey = () => {
  const wizardSteps: WizardProps['stepsConfig'] = [
    {
      label: '',
      steps: [
        {
          label: 'Employee Start Survey',
          component: <EmployeeStartSurvey />,
          showSkipButton: false,
          showPreviousButton: true,
        },
        {
          label: 'Employee Complete Survey',
          // eslint-disable-next-line react/no-unstable-nested-components
          component: ({ wizardNavigationButton }) => (
            <EmployeeCompleteSurvey wizardNavigationButton={wizardNavigationButton} />
          ),
          showSkipButton: false,
          showNextButton: false,
          showPreviousButton: false,
        },
        {
          label: 'TYP',
          component: <ConfigurationCompletedThankYouPage.Learning />,
          isTyp: true,
        },
      ],
    },
  ];

  /**
   * Reset wizard state on component mount.
   *
   * This is necessary because:
   * 1. The wizard store is a global singleton that persists across navigation
   * 2. When navigating directly to WizardSurvey (e.g., from LearningFirstConfiguration or bypassing it),
   *    the previous wizard's state might still be present
   * 3. Without resetting, callbacks from previous wizards could interfere with the current wizard,
   *    or button states (loading, disabled) could be incorrectly carried over
   *
   * This ensures a clean slate when entering a new survey wizard, regardless of the navigation path.
   */
  useEffect(() => {
    wizardStore.resetButtons();
    wizardStore.resetCallbacks();
  }, []);

  return <Wizard stepsConfig={wizardSteps} />;
};
